module.exports = __webpack_public_path__ + "img/playlist-thumbnail@2x.3d9e896d.png";